"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ShieldCheckSolid: function() {
        return ShieldCheckSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ShieldCheckSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M12.7071 1.29289C12.3166 0.902369 11.6834 0.902369 11.2929 1.29289C10.1999 2.38594 8.71737 3 7.17157 3H3C2.44772 3 2 3.44772 2 4V12.801C2 16.3577 4.0946 19.5808 7.34475 21.0253L11.5939 22.9138C11.8524 23.0287 12.1476 23.0287 12.4061 22.9138L16.6552 21.0253C19.9054 19.5808 22 16.3577 22 12.801V4C22 3.44772 21.5523 3 21 3H16.8284C15.2826 3 13.8001 2.38594 12.7071 1.29289ZM16.7372 9.67573C17.1104 9.26861 17.0828 8.63604 16.6757 8.26285C16.2686 7.88966 15.636 7.91716 15.2629 8.32428L10.5 13.5201L8.73716 11.597C8.36397 11.1899 7.7314 11.1624 7.32428 11.5356C6.91716 11.9088 6.88966 12.5413 7.26285 12.9485L9.76285 15.6757C9.95226 15.8824 10.2197 16 10.5 16C10.7803 16 11.0477 15.8824 11.2372 15.6757L16.7372 9.67573Z",
        fill: "currentColor"
    })
}), "ShieldCheckSolid");
const _default = ShieldCheckSolid;
